"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var react_1 = __importDefault(require("react"));
var react_svg_1 = require("react-svg");
var utils_1 = require("../../utils");
var icons_1 = require("./icons");
// TODO: make animation of icons better
var rotate180up = styled_components_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(180deg);\n    }\n"], ["\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(180deg);\n    }\n"])));
var rotate180down = styled_components_1.keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    from {\n        transform: rotate(180deg);\n    }\n    to {\n        transform: rotate(0deg);\n    }\n"], ["\n    from {\n        transform: rotate(180deg);\n    }\n    to {\n        transform: rotate(0deg);\n    }\n"])));
var chooseIconAnimationType = function (canAnimate, isActive) {
    if (canAnimate) {
        if (isActive) {
            return rotate180up;
        }
        return rotate180down;
    }
    return null;
};
var SvgWrapper = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: ", "px;\n    width: ", "px;\n    animation: ", " 0.2s linear 1\n        forwards;\n\n    div {\n        display: flex;\n        height: ", "px;\n        line-height: ", "px;\n        align-items: center;\n        justify-content: center;\n    }\n\n    span {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    :hover {\n        path {\n            fill: ", ";\n        }\n    }\n\n    ", "\n"], ["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: ", "px;\n    width: ", "px;\n    animation: ", " 0.2s linear 1\n        forwards;\n\n    div {\n        display: flex;\n        height: ", "px;\n        line-height: ", "px;\n        align-items: center;\n        justify-content: center;\n    }\n\n    span {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    :hover {\n        path {\n            fill: ", ";\n        }\n    }\n\n    ",
    "\n"])), function (props) { return props.size; }, function (props) { return props.size; }, function (props) { return chooseIconAnimationType(props.canAnimate, props.isActive); }, function (props) { return props.size; }, function (props) { return props.size; }, function (props) { return props.hoverColor; }, function (props) {
    return props.useCursorPointer && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            cursor: pointer;\n        "], ["\n            cursor: pointer;\n        "])));
});
var Icon = react_1.default.forwardRef(function (_a, ref) {
    var icon = _a.icon, _b = _a.size, size = _b === void 0 ? 24 : _b, color = _a.color, isActive = _a.isActive, canAnimate = _a.canAnimate, hoverColor = _a.hoverColor, useCursorPointer = _a.useCursorPointer, className = _a.className, onClick = _a.onClick, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onFocus = _a.onFocus, rest = __rest(_a, ["icon", "size", "color", "isActive", "canAnimate", "hoverColor", "useCursorPointer", "className", "onClick", "onMouseEnter", "onMouseLeave", "onFocus"]);
    var theme = utils_1.useTheme();
    var defaultColor = color !== null && color !== void 0 ? color : theme.TYPE_LIGHT_GREY;
    return (react_1.default.createElement(SvgWrapper, __assign({ className: className, canAnimate: canAnimate, hoverColor: hoverColor, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, isActive: isActive, size: size, ref: ref, useCursorPointer: onClick !== undefined || useCursorPointer, color: defaultColor }, rest),
        react_1.default.createElement(react_svg_1.ReactSVG, { src: icons_1.ICONS[icon], beforeInjection: function (svg) {
                svg.setAttribute('width', size + "px");
                svg.setAttribute('height', size + "px");
                svg.setAttribute('fill', defaultColor);
            }, loading: function () { return react_1.default.createElement("span", { className: "loading" }); } })));
});
exports.Icon = Icon;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
